// extracted by mini-css-extract-plugin
export default {"MonitorCard_Root":"MonitorCard_MonitorCard_Root__6KCWL","MonitorCard_PropertyListContainer":"MonitorCard_MonitorCard_PropertyListContainer__9y+dM"};